const env = {domain: 'SO'};
module.exports=env;


// WEBPACK FOOTER //
// ./config/env.js